import { MappedFormItem } from '@/components/elements/form-map/form-map.component.core';
import { IntlShape } from 'react-intl';
import { productGroupFormTranslations } from '../../product-groups.messages';

export const productMap = (intl: IntlShape): MappedFormItem[] => {
  const map: MappedFormItem[] = [
    {
      name: 'name',
      label: intl.formatMessage(productGroupFormTranslations.nameInputLabel),
      placeholder: intl.formatMessage(productGroupFormTranslations.nameInputPlaceholder),
      required: true,
      type: 'input',
    },
    {
      name: 'description',
      label: intl.formatMessage(productGroupFormTranslations.descriptionInputLabel),
      placeholder: intl.formatMessage(productGroupFormTranslations.descriptionInputPlaceholder),
      required: true,
      type: 'textarea',
    },
  ];
  return map;
};
